module.exports = __webpack_public_path__ + "media/images/items/static-7-f3cbb50e507bbf4b4510f1d65d665349.jpg";